import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const rollDown = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

const MessageBox = styled.div`
  width: 30vw;
  position: fixed;
  top: 0;
  transform: translateX(-50%);
  background-color: #f0852e;
  color: white;
  padding: 2rem;
  border-radius: 4px;
  animation: ${rollDown} 0.5s ease-out forwards;
  box-shadow: 0px 3px 5px rgba(0,0,0,0.2);
  z-index: 1000;
  cursor: pointer;
  white-space: pre-wrap;

  /* Hide the message box after animation if it's not hovered */
  &:not(:hover) {
    animation: ${rollDown} 0.5s ease-out forwards, fadeOut 0.5s 5s forwards;
  }

  @keyframes fadeOut {
    to {
      opacity: 0;
      visibility: hidden;
    }
  }
`;

interface ErrorSnackbarProps {
    message: string;
    onClose?: () => void;
}


const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ message, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            onClose && onClose();
        }, 5000);

        return () => clearTimeout(timer);
    }, [onClose]);

    if (!isVisible) return null;

    return (
        <MessageBox onClick={() => setIsVisible(false)}>
            Błąd: {message}
        </MessageBox>
    );
}

export default ErrorSnackbar;